import {
  BULKIMPORT_SET,
  BULKIMPORT_SET_SUCCESS,
  BULKIMPORT_SET_ERROR,
  CANDIDATE_SET,
  JOB_SET,
  ORG_DETAIL_GET_LIST,
  ORG_DETAIL_GET_LIST_SUCCESSFULL,
  ORG_DETAIL_GET_LIST_FAILED,
  GET_JOB_PROFILES,
  GET_JOB_PROFILES_SUCCESS,
  GET_JOB_PROFILES_FAILED,
  GET_CANDIDATE_BULK_IMPORT_STATUS,
  GET_CANDIDATE_BULK_IMPORT_STATUS_SUCCESS,
  GET_CANDIDATE_BULK_IMPORT_STATUS_FAILED,
  DELETE_ALL_RESUMES,
  DELETE_ALL_RESUMES_SUCCESS,
  DELETE_ALL_RESUMES_FAILED,
  GET_JOB_BULK_IMPORT_STATUS,
  GET_JOB_BULK_IMPORT_STATUS_SUCCESS,
  GET_JOB_BULK_IMPORT_STATUS_FAILED,
  DELETE_ALL_DESCRIPTIONS,
  DELETE_ALL_DESCRIPTIONS_SUCCESS,
  DELETE_ALL_DESCRIPTIONS_FAILED,
  DELETE_JD_REPOSITORY,DELETE_JD_REPOSITORY_STATUS_SUCCESS ,DELETE_JD_REPOSITORY_STATUS_FAIL, GET_JOB_PROFILES_SUGGESTION, GET_JOB_PROFILES_SUGGESTION_SUCCESS, GET_JOB_PROFILES_SUGGESTION_FAILED, GET_SAMPLE_CSV_JD_FILE, GET_SAMPLE_CSV_JD_FILE_SUCCESS, GET_SAMPLE_CSV_JD_FILE_FAILED,GET_SAMPLE_CSV_RESUME_FILE,GET_SAMPLE_CSV_RESUME_FILE_SUCCESS,GET_SAMPLE_CSV_RESUME_FILE_FAILED
} from "./actionTypes"

const initialState = {
  
  bulkimportError: null,
  user:null,
  loading:false,
  orgData:null,
  jobProfiles:null,
  jobProfilesError:null,
  candidateResumeStatuses:null,
  candidateResumeStatusesFailed:null,
  deleteResumes:null,
  deleteResumesFailed:null,
  jobDescriptionStatuses:null,
   jobDescriptionStatusesFailed:null,
   displayCloseBtn:true,
   deleteDescriptions:null,
   deleteDescriptionsFailed:null,
   jdLoader:false,
   jdRepositorySuccess: null,
   jdRepositoryError: null,
   jobProfileSuggestions: null,
   jobProfileSuggestionsError : null,
   sampleCsvJd:null,
   sampleCsvResume:null
}

const bulkimportreducer = (state = initialState, action) => {
  switch (action.type) {
    case BULKIMPORT_SET:
      state = {
        ...state,
        user: null,
        bulkimportError: null,
        loading:true,
        
      }
      break
    case BULKIMPORT_SET_SUCCESS:
      state = {
        ...state,
        user: action.payload,
        bulkimportError:null,
        loading:false,
       
      }
      break
    case BULKIMPORT_SET_ERROR:
      state = {
         ...state, 
         bulkimportError: action.payload,
         loading:false,
         displayCloseBtn:true,
        }
      break
    case CANDIDATE_SET :
      state = {
         ...state, 
         user: action.payload,
         bulkimportError: null,
         loading:true,
         displayCloseBtn:false,
        } 
      break
    case JOB_SET :
      state = {
         ...state, 
         user: action.payload,
         bulkimportError: null,
         loading:true,
         displayCloseBtn:false,
        } 
      break
      case ORG_DETAIL_GET_LIST :
        state = {
           ...state, 
           user: action.payload,
           bulkimportError: null,
           loading:true
          } 
        break
        case ORG_DETAIL_GET_LIST_SUCCESSFULL:
          state = {
             ...state, 
             orgData: action.payload,
             bulkimportError: null,
             loading:false
            } 
          break
          case ORG_DETAIL_GET_LIST_FAILED:
            state = {
               ...state, 
               orgData: null,
               bulkimportError: action.payload,
               loading:false
              } 
            break

            case GET_JOB_PROFILES:
            state = {
               ...state, 
               loading: true,
               jobProfiles:null,
               jobProfilesError:null,
               jdLoader:true,
              } 
            break

            case GET_JOB_PROFILES_SUCCESS:
            state = {
               ...state, 
               loading:false,
               jobProfiles:action.payload,
               jobProfilesError:null,
               jdLoader:false,
              } 
            break
            case GET_JOB_PROFILES_FAILED:
              state = {
                 ...state, 
                 loading: false,
                 jobProfiles:null,
                 jobProfilesError:action.payload,
                 jdLoader:false
                } 
              break

              case GET_CANDIDATE_BULK_IMPORT_STATUS:
              state = {
                 ...state, 
                 loading: false,
                 candidateResumeStatuses:null,
                 candidateResumeStatusesFailed:null,
                 displayCloseBtn:true
                } 
              break
              case GET_CANDIDATE_BULK_IMPORT_STATUS_SUCCESS:
              state = {
                 ...state, 
                 loading: false,
                 candidateResumeStatuses:action.payload,
                 candidateResumeStatusesFailed:null
                } 
              break
              case GET_CANDIDATE_BULK_IMPORT_STATUS_FAILED:
                state = {
                   ...state, 
                   loading: false,
                   candidateResumeStatuses:null,
                   candidateResumeStatusesFailed:action.payload,
                  } 
                break
                case DELETE_ALL_RESUMES:
                state = {
                   ...state, 
                   loading: true,
                   deleteResumes:null,
                   deleteResumesFailed:null,
                  } 
                break
                case DELETE_ALL_RESUMES_SUCCESS:
                state = {
                   ...state, 
                   loading:false,
                   deleteResumes:action.payload,
                   deleteResumesFailed:null,
                  } 
                break
                case DELETE_ALL_RESUMES_FAILED:
                state = {
                   ...state, 
                   loading:false,
                   deleteResumes:null,
                   deleteResumesFailed:null,
                  } 
                break
                case GET_JOB_BULK_IMPORT_STATUS:
                  state = {
                     ...state, 
                     loading: false,
                     jobDescriptionStatuses:null,
                     jobDescriptionStatusesFailed:null,
                     displayCloseBtn:true
                    } 
                  break
                  case GET_JOB_BULK_IMPORT_STATUS_SUCCESS:
                    state = {
                       ...state, 
                       loading: false,
                       jobDescriptionStatuses:action.payload,
                       jobDescriptionStatusesFailed:null
                      } 
                    break
                    case GET_JOB_BULK_IMPORT_STATUS_FAILED:
                    state = {
                       ...state, 
                       loading: false,
                       jobDescriptionStatuses:null,
                       jobDescriptionStatusesFailed:action.payload,
                      } 
                    break
                    case DELETE_ALL_DESCRIPTIONS:
                    state = {
                       ...state, 
                       loading: true,
                       deleteDescriptions:null,
                       deleteDescriptionsFailed:null,
                      } 
                    break
                    case DELETE_ALL_DESCRIPTIONS_SUCCESS:
                      state = {
                         ...state, 
                         loading: false,
                         deleteDescriptions:action.payload,
                         deleteDescriptionsFailed:null,
                        } 
                      break
                      case DELETE_ALL_DESCRIPTIONS_FAILED:
                      state = {
                         ...state, 
                         loading: false,
                         deleteDescriptions:null,
                         deleteDescriptionsFailed:action.payload,
                        } 
                      break
                           //jd repository delete

                           case DELETE_JD_REPOSITORY:
                            state = {
                               ...state, 
                               loading: true,
                               jdRepositorySuccess: null,
                               jdRepositoryError: null,
                              } 
                            break
                            case DELETE_JD_REPOSITORY_STATUS_SUCCESS:
                              state = {
                                 ...state, 
                                 loading: false,
                                 jdRepositorySuccess: action.payload,
                                 jdRepositoryError: null,
                                } 
                              break
                              case DELETE_JD_REPOSITORY_STATUS_FAIL:
                              state = {
                                 ...state, 
                                 loading: false,
                                 jdRepositorySuccess: null,
                                 jdRepositoryError:  action.payload,
                                } 
                              break
      //jd repository delete

                           case GET_JOB_PROFILES_SUGGESTION:
                            state = {
                               ...state, 
                               jobProfileSuggestions: null,
                               jobProfileSuggestionsError: null,
                              } 
                            break
                            case GET_JOB_PROFILES_SUGGESTION_SUCCESS:
                              state = {
                                 ...state, 
                                 loading: false,
                                 jobProfileSuggestions: action.payload,
                                 jobProfileSuggestionsError: null,
                                } 
                              break
                              case GET_JOB_PROFILES_SUGGESTION_FAILED:
                              state = {
                                 ...state, 
                                 loading: false,
                                 jobProfileSuggestions: null,
                                 jobProfileSuggestionsError:  action.payload,
                                } 
                              break
                              case GET_SAMPLE_CSV_JD_FILE:
                              state = {
                                 ...state, 
                                 loading: false,
                                 sampleCsvJd:null,
                                 sampleCsvResume:null
                                } 
                              break
                              case GET_SAMPLE_CSV_JD_FILE_SUCCESS:
                                state = {
                                   ...state, 
                                   loading: false,
                                   sampleCsvJd:action.payload,
                                   sampleCsvResume:null
                                  } 
                                break
                                case GET_SAMPLE_CSV_JD_FILE_FAILED:
                                  state = {
                                     ...state, 
                                     loading: false,
                                     sampleCsvJd:null,
                                     sampleCsvResume:action.payload
                                    } 
                                  break
                                  case GET_SAMPLE_CSV_RESUME_FILE:
                              state = {
                                 ...state, 
                                 loading: false,
                                 sampleCsvJd:null,
                                 sampleCsvResume:null
                                } 
                              break
                              case GET_SAMPLE_CSV_RESUME_FILE_SUCCESS:
                                state = {
                                   ...state, 
                                   loading: false,
                                   sampleCsvJd:null,
                                   sampleCsvResume:action.payload
                                  } 
                                break
                                case GET_SAMPLE_CSV_RESUME_FILE_FAILED:
                                  state = {
                                     ...state, 
                                     loading: false,
                                     sampleCsvJd:null,
                                     sampleCsvResume:null
                                    } 
                                  break

    default:
      state = { ...state }
      break
  }
  return state
}

export default bulkimportreducer
